"use client";

import { useEffect } from "react";
import { hydrateCart } from "@/lib/cart-store";

/**
 * Mounts in the root layout. Triggers a one-time read of the persisted cart
 * from localStorage on first client paint, plus subscribes to cross-tab
 * `storage` events. Renders nothing.
 */
export function CartHydrator() {
  useEffect(() => {
    hydrateCart();
  }, []);
  return null;
}
